import { MenuItem } from '@material-ui/core'
import { Select } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLanguage } from 'src/core/components/LanguageProvider/hooks'
import getNavigatorLanguage from 'src/utils/getNavigatorLanguage'
import useStyles from './useStyles'
interface Props {
  [key: string]: unknown
}

const LanguageButton: React.FC<Props> = (props) => {
  const classes = useStyles()
  const { language, setLanguage } = useLanguage()
  if (language !== 'en' && language !== 'zh-TW') {
    let lang = getNavigatorLanguage()
    if (lang.includes('en')) {
      lang = 'en'
    }
    setLanguage && setLanguage(lang)
    window.localStorage.setItem('language', lang)
  }
  const { i18n } = useTranslation()

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newLanguage = event.target.value as string

    window.localStorage.setItem('language', newLanguage)
    setLanguage && setLanguage(newLanguage)
    i18n.changeLanguage(newLanguage)
  }

  return (
    <Select
      {...props}
      IconComponent={ExpandMoreIcon}
      disableUnderline
      value={language}
      MenuProps={{
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        style: { zIndex: 1600 },
      }}
      onChange={handleChange}
    >
      <MenuItem value='zh-TW' className={classes.menuItem}>
        繁體中文
      </MenuItem>
      <MenuItem value='en' className={classes.menuItem}>
        English
      </MenuItem>
    </Select>
  )
}

export default LanguageButton
